// src/lib/sanity.js
import { createClient } from "@sanity/client";

export const client = createClient({
  projectId: "bl562rvf",
  dataset: "production",
  apiVersion: "2023-07-29",
  useCdn: true, // ok for public, published data
});
